<ambita-landregistry-cadastre-selector>
  <div>
    <form class="ambita-landregistry-selector__cadastre-key" onsubmit="{ formSubmit }">
      <input class="ambita-landregistry-selector__cadastre-key"
             if="{ isValidTokenAvailable }" ref="cadastreKeyInput"
             placeholder="<knr>-<gnr>-<bnr>-<fnr>-<snr>" value="{cadastreKey}"/>
      <input class="ambita-landregistry-selector__cadastre-key" if="{ !isValidTokenAvailable }"
             placeholder="{ i18n.common.loginRequired }" disabled/>
      <br>
      <select ref="stateSelect" class="ambita-landregistry-selector__state" onchange="{ formSubmit }">
        <option value="active" selected="selected">Aktive data</option>
        <option value="historical">Historiske data</option>
        <option value="active_and_historical">Både aktive og historiske data</option>
      </select>
    </form>
  </div>
  <script>
    import { init } from './landRegistryCadastreSelectorController';
    import './landRegistryCadastreSelector.scss';
    import '../../i18n/commonTranslations';

    init(this);
  </script>
</ambita-landregistry-cadastre-selector>
